import {_pHttp} from "../_pHttp";

// export type Role = {
//   roles:{
//     _id?: string;
//     name: string;
//     faName: string;
//     description: string;
//     created_at: string}[]
  
// }

export const getRoles =async ()=>{
  // const {data} = await _pHttp.get(`/role?page=${page}&search=${search}`)
  const {data} = await _pHttp.get(`/role?page=1&search=`)
  return data
}

export const getRolesّForm = async () => {
  try {
    const {data} = await _pHttp.get(`/role/all`);
    return data;
  } catch (error) {
    console.error("Error in getRolesّForm:", error);
    throw error;
  }
}

export const getRole =async ({id}:{id:string|number|undefined})=>{
  // const {data} = await _pHttp.get(`/role?page=${page}&search=${search}`)
  const {data} = await _pHttp.get(`/role/${id}`)
  return data
}

export const getRolesPerPage =async ({page=1,search=""}:any)=>{
  const {data} = await _pHttp.get(`/role?page=${page}&search=${search}`)
  return data;
}

export const addRole =async (body : any)=>{
  await _pHttp.post(`/role`, body);
}

export const editRole =async (body : any)=>{
  await _pHttp.post(`/role/update`, body);
}

export const deleteRole = async (id:string|number)=>{
  await  _pHttp.delete(`/role/${id}`)
}

// export const getRoles =async ()=>{
//   // const {data} = await _pHttp.get(`/role?page=${page}&search=${search}`)
//   const {data} = await _pHttp.get(`/role?page=1&search=`)
//   return data
// }
// const data = await _http.get<Category[]>(`category/getAll`);

// export const getRoles =async ({page=1,search=""}:{page?:string|number;search?:string})=>{
//   // const {data} = await _pHttp.get(`/role?page=${page}&search=${search}`)
//   const {data} = await _pHttp.get(`/role?page=1&search=`)
//     return data
// }

// export const getOperator =async ({id}:{id:string|number})=>{
//   const {data} = await _pHttp.get(`/operator/${id}`)
//     return data
// }

// export const editOperators =async ({body}:{body:Operator})=>{
//   const {_id,...rest} = body
//   await _pHttp.post(`/operator/${body._id}`, rest);
// }

// export const deleteOperators =async ({id}:{id:string|number})=>{
//   const {data} = await _pHttp.delete(`/operator/delete/${id}`);
//     return data
// }
